import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import vuetify from './plugins/vuetify';
import '@/assets/css/style.scss';
import '@/filters';
import './permission';
import GAuth from '@/plugins/vueGoogleOauth2';
Vue.config.productionTip = false;
const gauthOption = {
    clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: 'profile email',
    prompt: 'consent',
    hosted_domain: 'clo3d.com' // eslint-disable-line
};
Vue.use(GAuth, gauthOption);
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
